import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ArchiveIcon, CopyIcon } from 'lucide-react';
interface BulkActionsBarProps {
  isOpen: boolean;
  selectedCount: number;
  onCancel: () => void;
  onArchive: () => void;
  onRecreate?: () => void; // Optional for future use or if we want direct recreate
}
export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  isOpen,
  selectedCount,
  onCancel,
  onArchive
}) => {
  return <AnimatePresence data-id="element-902">
      {isOpen && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-6 left-0 right-0 z-40 flex justify-center px-4 pointer-events-none" data-id="element-903">
          <div className="bg-surface-elevated border border-custom shadow-2xl rounded-2xl p-3 flex items-center gap-4 pointer-events-auto min-w-[320px] max-w-md w-full" data-id="element-904">
            <div className="flex items-center gap-3 pl-2 flex-1" data-id="element-905">
              <div className="bg-[#00B75F] text-white text-xs font-bold px-2 py-1 rounded-md" data-id="element-906">
                {selectedCount}
              </div>
              <span className="text-sm font-semibold text-text-primary" data-id="element-907">
                Selected
              </span>
            </div>

            <div className="h-8 w-px bg-border" data-id="element-908" />

            <div className="flex items-center gap-2" data-id="element-909">
              <button onClick={onArchive} disabled={selectedCount === 0} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${selectedCount > 0 ? 'bg-red-50 text-red-600 hover:bg-red-100' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`} data-id="element-910">
                <ArchiveIcon size={16} data-id="element-911" />
                Archive
              </button>

              <button onClick={onCancel} className="p-2 text-text-secondary hover:text-text-primary hover:bg-surface rounded-xl transition-colors" aria-label="Cancel selection" data-id="element-912">
                <XIcon size={20} data-id="element-913" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};